var tiendas = [
{"punto_id":"4","ciudad":"BOGOTA","nombre":"ANDINO","centro_comercial":"ANDINO","direccion":"CR. 11 # 82-77","local":"3 22","telefono":"(1)611-32-66","correo":"legostore.bogota@continente.com.co","horario_l_j":"10am - 8pm","horario_v_s":"10am-9pm","horario_d_f":"11am-7pm","imagen_tienda":"catalog\/tiendas\/andino.jpg","latitud":"4.666310","longitud":"-74.052647"},
{"punto_id":"6","ciudad":"BOGOTA","nombre":"SANTAFÉ","centro_comercial":"SANTAFÉ","direccion":"Calle 185 No.45 - 03 - Costado Occidental Autopista Norte","local":"275","telefono":"(1)605-08-72","correo":"legostore.santafe@continente.com.co","horario_l_j":"10am - 8pm","horario_v_s":"10am-9pm","horario_d_f":"11am-8pm","imagen_tienda":"catalog\/tiendas\/Santa Fé 2.JPG","latitud":"4.762173","longitud":"-74.045041"},
{"punto_id":"7","ciudad":"BOGOTA","nombre":"TITÁN","centro_comercial":"TITÁN PLAZA","direccion":"CALLE 80 CON AVENIDA BOYACÁ","local":"355","telefono":"(1)609-29-67","correo":"legostore.titan@continente.com.co","horario_l_j":"10am - 8pm","horario_v_s":"10am-9pm","horario_d_f":"11am-7pm","imagen_tienda":"catalog\/tiendas\/titan.jpg","latitud":"4.694238","longitud":"-74.087068"},
{"punto_id":"8","ciudad":"BARRANQUILLA","nombre":"BUENAVISTA 2","centro_comercial":"BUENAVISTA2","direccion":"CALLE 96 # 53-52 CC BUENAVSTA 2","local":"405","telefono":"(5)318-74-88","correo":"legostore.buenavista@continente.com.co","horario_l_j":"10am - 8pm","horario_v_s":"10am-9pm","horario_d_f":"11am-7pm","imagen_tienda":"catalog\/tiendas\/Buenavista3.jpg","latitud":"11.013726","longitud":"-74.827750"},
{"punto_id":"9","ciudad":"CALI","nombre":"CALI","centro_comercial":"JARDIN PLAZA","direccion":"CC JARDIN PLAZA CRA.98 #16-200","local":"115","telefono":"(2)388-59-00","correo":"legostore.cali@continente.com.co","horario_l_j":"10am - 8pm","horario_v_s":"10am - 9pm","horario_d_f":"11am-8pm","imagen_tienda":"catalog\/tiendas\/jardin.jpg","latitud":"3.366795","longitud":"-76.527878"},
{"punto_id":"10","ciudad":"MEDELLIN","nombre":"EL TESORO","centro_comercial":"EL TESORO","direccion":"CC EL TESORO CRA 25 A # 1A SUR 45","local":"3036","telefono":"(4)321-71-53","correo":"legostore.tesoro@continente.com.co","horario_l_j":"10am - 9pm","horario_v_s":"10am-9pm","horario_d_f":"11am-8pm","imagen_tienda":"catalog\/tiendas\/tesoro.jpg","latitud":"6.196679","longitud":"-75.558622"},
{"punto_id":"11","ciudad":"ENVIGADO","nombre":"VIVA ENVIGADO","centro_comercial":"VIVA ENVIGADO","direccion":"Cra 48 #32 sur – 139","local":"126","telefono":"(034)4799540","correo":"tiendalego@continente.com.co","horario_l_j":"10am - 9pm","horario_v_s":"10am - 9pm","horario_d_f":"11am - 8pm","imagen_tienda":"catalog\/tiendas\/VivaEnvigado.jpg","latitud":"6.172985038841679","longitud":"-75.59231698471177"}
];


var map = {};

var siteURL = "x";
if (document.domain === "localhost") siteURL = "x";
$(document).ready(function() {
  
    $( ".info_punto" ).hover(
      function() {
        $( ".info_punto" ).height(170);
      }, function() {
        $( ".info_punto" ).height(75);
      }
    );


    function render_map($el) {

       
        var args = {
            center: new google.maps.LatLng(4.666064, -74.053018),
            backgroundColor: "#ffffff",
            zoom: 12,
            disableDefaultUI: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
                style: google.maps.ZoomControlStyle.SMALL
            },
            disableDoubleClickZoom: true,
            panControl: true,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            mapTypeControl: true,
            scaleControl: false,
            scrollwheel: true,
            streetViewControl: true,
            draggable: true,
            overviewMapControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        map = new google.maps.Map($el[0], args);
        map.markers = [];
      
        	
        stores.forEach(function(punto) {
            add_marker(punto, map);
        });
        return map;
    }

    function add_marker(punto, map) {
        var latlng = new google.maps.LatLng(punto.latitud, punto.longitud);
        var icon = null;
        icon = "https://tiendalego.com.co/image/tienda.png";
        var marker = new google.maps.Marker({
            icon: new google.maps.MarkerImage(icon),
            optimized: false,
            position: latlng,
            map: map,
            zIndex: null,
            animation: google.maps.Animation.DROP,
            filter: {
                main: punto.ciudad,
                id: punto.punto_id,
            }
        });
      console.log(marker)
        map.markers.push(marker);
       
            google.maps.event.addListener(marker, "click", function() {
              console.log('clicl');
              console.log(marker.filter.id)  
              var point = stores.filter(store => store.punto_id == marker.filter.id)[0]
              console.log(point)
              $('#nombre_tienda').html('TIENDA LEGO ' + point.ciudad + ' CC ' + point.centro_comercial)
              $('#direccion_tienda').html(point.direccion)
              $('#local_tienda').html(point.local)
              $('#telefono_tienda').html(point.telefono)
              $('#correo_tienda').html(point.correo)
              $('#horario_l_j_tienda').html(point.horario_l_j)
              $('#horario_v_s_tienda').html(point.horario_v_s)
              $('#horario_d_f_tienda').html(point.horario_d_f)
              var src = point.imagen_tienda;
              $('#imagen_tienda').attr("src", src);
            });
            $(document).on("click", ".ac-main", function(e) {
                e.preventDefault();
                map.setZoom(12);
            });
    }

    function center_map(map) {
        var bounds = new google.maps.LatLngBounds();
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });
        map.fitBounds(bounds);
    }
    $(document).ready(function() {
      var option = '';
      for (var i=0;i<cities.length;i++){
         option += '<option value="'+ cities[i].id + '">' + cities[i].name + '</option>';
      }
      $('#cities-filter').append(option);

        var map = null;
        $(".map-canvas").each(function() {
            map = render_map($(this));
        });
        $(document).on("click", ".filters a", function(e) {
            e.preventDefault();
            var
                $target = $(e.target),
                type = $target.data("filterby"),
                value = $target.data("filtervalue");
            map.setOptions({
                scrollwheel: true
            });
            $.each(map.markers, function() {
                if (type === "central" || type === "category" || type === "item") {
                    var grupo = this.filter[type]();
                    if (grupo.indexOf(value) !== -1) {
                        if (this.map === null) {
                            this.setMap(map);
                        }
                        map.panTo(this.getPosition());
                    } else {
                        this.setMap(null);
                    }
                } else {
                    if (this.filter[type] === value) {
                        if (this.map === null) {
                            this.setMap(map);
                        }
                        map.panTo(this.getPosition());
                    } else {
                        this.setMap(null);
                    }
                }
            });
        });
    });
    $('#nombre_tienda').html('TIENDA LEGO ' + stores[0].ciudad + ' CC ' + stores[0].centro_comercial)
	$('#direccion_tienda').html(stores[0].direccion)
	$('#local_tienda').html(stores[0].local)
	$('#telefono_tienda').html(stores[0].telefono)
	$('#correo_tienda').html(stores[0].correo)
	$('#horario_l_j_tienda').html(stores[0].horario_l_j)
	$('#horario_v_s_tienda').html(stores[0].horario_v_s)
	$('#horario_d_f_tienda').html(stores[0].horario_d_f)
    var src = stores[0].imagen_tienda;
	$('#imagen_tienda').attr("src", src);
});
function changeCity(sel) {
  var city = cities.filter(city => city.id == sel.value)[0];
  console.log(city);
  map.panTo(city.latLng); //Make map global
  map.setZoom(13);
}
